import { Quote } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";
import { ASSETS, CEO } from "../data/content";

export const Leadership = () => (
  <section
    id="leadership"
    data-testid="leadership-section"
    className="bg-[#F8FAFC] py-24 lg:py-32"
  >
    <div className="mx-auto max-w-[1400px] px-5 lg:px-10">
      <div className="grid gap-14 lg:grid-cols-12 lg:gap-20 items-start">
        <Reveal className="lg:col-span-5">
          <div className="relative max-w-[260px] sm:max-w-[300px]">
            <div className="absolute -left-3 -top-3 h-full w-full border border-[#D4AF37]/50" />
            <img
              src={ASSETS.ceo}
              alt={CEO.name}
              data-testid="ceo-photo"
              className="relative w-full h-[320px] sm:h-[360px] object-cover object-top rounded-sm shadow-sm"
            />
          </div>
          <div className="mt-8 max-w-[300px]">
            <h3 className="font-display text-2xl font-extrabold tracking-tight text-[#0A192F]">
              {CEO.name}
            </h3>
            <p className="mt-1 text-xs font-bold uppercase tracking-[0.2em] text-[#B08D2A]">
              {CEO.role}
            </p>
            <p className="mt-4 text-sm leading-relaxed text-slate-600">{CEO.credentials}</p>
          </div>
        </Reveal>

        <Reveal delay={0.1} className="lg:col-span-7">
          <SectionLabel>About Our Executives</SectionLabel>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight tracking-tight text-[#0A192F]">
            A message from our Managing Director
          </h2>

          <Quote size={38} className="mt-10 text-[#D4AF37]" />
          <p className="mt-6 text-base md:text-lg leading-relaxed text-slate-700">{CEO.bio}</p>
          <p className="mt-6 border-l-2 border-[#D4AF37] pl-6 text-base leading-relaxed text-[#0A192F] font-medium">
            {CEO.highlight}
          </p>
          <p className="mt-6 text-base leading-relaxed text-slate-600">{CEO.closing}</p>

          <div className="mt-10 border-t border-slate-200 pt-6">
            <p className="font-display text-lg font-bold text-[#0A192F]">{CEO.name}</p>
            <p className="text-xs uppercase tracking-[0.2em] text-slate-500">{CEO.role}</p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
